var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.type === 'prependCircle')?_c('span',{staticClass:"pr-16 text-sm align-middle inline-flex items-center"},[_c('span',{staticClass:"rounded-full inline-flex flex-initial p-4 pl-8 pt-8 m-4 ml-0 mr-8",class:[
      _vm.bgColor,
      _vm.textColor ]}),_c('span',{staticClass:"inline-flex flex-grow"},[_vm._v(_vm._s(_vm.label))])]):_c('span',{staticClass:"rounded-full text-sm font-bold align-middle inline-flex items-center",class:[
    _vm.bgColor,
    _vm.textColor,
    _vm.dense ? 'py-2 px-8 ' : 'py-4 px-16'
  ]},[_c('span',[_vm._v(_vm._s(_vm.label))]),(_vm.clearable)?_c('v-icon',{staticClass:"text-secondary-200 cursor-pointer hover:text-white text-lg ml-4",class:[
      _vm.clearColor,
      _vm.clearHoverColor ],on:{"click":_vm.clear}},[_vm._v(" mdi-close ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }